import React from 'react'
import { UrlBuilder } from './UrlBuilder'

const getLink = (rel, val, location) => {
  const path = `${location.pathname}${val}`
  return <link rel={rel} href={path} key={val} />
}

export const getPaginationRels = props => {
  const { location, totalPages } = props
  let links = []

  const queryString = location.search
  const urlBuilder = new UrlBuilder(queryString)
  const urlBuilder2 = new UrlBuilder(queryString)
  const page = urlBuilder.getPage()

  if (page === 1) {
    links.unshift(
      getLink('next', urlBuilder.setPage(page + 1).getQueryString(), location)
    )
  }

  if (page > 1 && page < totalPages) {
    links.unshift(
      getLink('prev', urlBuilder.setPage(page - 1).getQueryString(), location),
      getLink('next', urlBuilder2.setPage(page + 1).getQueryString(), location)
    )
  }

  if (page === totalPages) {
    links.unshift(
      getLink('prev', urlBuilder.setPage(page - 1).getQueryString(), location)
    )
  }

  return links
}
